// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

// Common invalidate queries for sales orders.
const commonInvalidateQueries = (queryClient) => {
  // Invalidate sales orders.
  queryClient.invalidateQueries(t.SALE_ESTIMATE);
  queryClient.invalidateQueries(t.SALE_ESTIMATE);

  // Invalidate customers.
  queryClient.invalidateQueries(t.CUSTOMERS);
  queryClient.invalidateQueries(t.CUSTOMER);

  // Invalidate items.
  queryClient.invalidateQueries(t.ITEMS);
  queryClient.invalidateQueries(t.ITEM);

  // Invalidate settings.
  queryClient.invalidateQueries([t.SETTING, t.SETTING_SALE_ESTIMATES]);

  // Invalidate transactions/reports that may depend on sales orders.
  queryClient.invalidateQueries(t.FINANCIAL_REPORT);
  queryClient.invalidateQueries(t.TRANSACTIONS_BY_REFERENCE);

  // Invalidate accounts.
  queryClient.invalidateQueries(t.ACCOUNTS);
  queryClient.invalidateQueries(t.ACCOUNT);

  // Invalidate reconcile.
  queryClient.invalidateQueries(t.RECONCILE_CREDIT_NOTE);
  queryClient.invalidateQueries(t.RECONCILE_CREDIT_NOTES);

  // Invalidate item warehouses.
  queryClient.invalidateQueries(t.ITEM_WAREHOUSES_LOCATION);

  // Invalidate mutate base currency abilities.
  queryClient.invalidateQueries(t.ORGANIZATION_MUTATE_BASE_CURRENCY_ABILITIES);
};

/**
 * Fetches the given estimate item details.
 */
export function useEstimateItemDetails(
  estimateId,
  itemId,
  props,
  requestProps,
) {
  return useRequestQuery(
    [t.ESTIMATE, estimateId, 'ITEM', itemId],
    {
      method: 'get',
      url: `estimates/${estimateId}/items/${itemId}`,
      ...requestProps,
    },
    {
      select: (res) => res.data,
      defaultData: {},
      ...props,
    },
  );
}

/**
 * Edits the given sales order item.
 */
export function useEstimateItem(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([estimateId, itemId, values]) =>
      apiRequest.put(`estimates/${estimateId}/items/${itemId}`, values),
    {
      onSuccess: (res, [estimateId]) => {
        // Invalidate specific estimate.
        queryClient.invalidateQueries([t.ESTIMATE, estimateId]);
        // Common invalidate queries.
        commonInvalidateQueries(queryClient);
      },
      ...props,
    },
  );
}

/**
 * Creates the given estimate item structure (lineItems/stages/etc) for an existing item entry.
 */
export function useCreateEstimateItem(props) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([estimateId, itemId, values]) =>
      apiRequest.post(`estimates/${estimateId}/items/${itemId}`, values),
    {
      onSuccess: (res, [estimateId]) => {
        queryClient.invalidateQueries([t.ESTIMATE, estimateId]);
        commonInvalidateQueries(queryClient);
      },
      ...props,
    },
  );
}
